import type { RootState } from '~/redux/store';
import type { Group } from '~/types/models';
import type { IRestIndexParams } from '~/types/states';

export const getParams = (state: RootState): IRestIndexParams<Group> => ({
  sortBy: state.groups.sortBy,
  page: state.groups.page,
  pageSize: state.groups.pageSize,
  with: state.groups.with.join(','),
  ...state.groups.filters,
});

export const getItem = (state: RootState): Group | null => state.groups.item;
